import {Component, Inject, Optional, ViewEncapsulation} from '@angular/core';

import {JdMessageConfig, JD_MESSAGE_CONFIG, JD_MESSAGE_DEFAULT_CONFIG} from './message-config';
import {JdMessageDataFilled, JdMessageDataOptions} from './message.definitions';

@Component({
  selector: 'jd-message-container',
  preserveWhitespaces: false,
  templateUrl: './message-container.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [``]
})
export class JdMessageContainerComponent {
  messages: JdMessageDataFilled[] = [];
  config: JdMessageConfig = {};

  constructor(@Optional() @Inject(JD_MESSAGE_DEFAULT_CONFIG) defaultConfig: JdMessageConfig,
              @Optional() @Inject(JD_MESSAGE_CONFIG) config: JdMessageConfig) {
    this.setConfig({...defaultConfig, ...config});
  }

  setConfig(config: JdMessageConfig): void {
    this.config = {...this.config, ...config};
  }

  // Create a new message
  createMessage(message: JdMessageDataFilled): void {
    if (this.messages.length >= this.config.jdMaxStack) {
      this.messages.splice(0, 1);
    }
    message.options = this._mergeMessageOptions(message.options);
    this.messages.push(message);
  }

  // Remove a message by messageId
  removeMessage(messageId: string): void {
    this.messages.some((message, index) => {
      if (message.messageId === messageId) {
        this.messages.splice(index, 1);
        return true;
      }
    });
  }

  // Remove all messages
  removeMessageAll(): void {
    this.messages = [];
  }

  // Merge default options and cutom message options
  protected _mergeMessageOptions(options: JdMessageDataOptions): JdMessageDataOptions {
    const defaultOptions: JdMessageDataOptions = {
      jdDuration: this.config.jdDuration,
      jdAnimate: this.config.jdAnimate,
      jdPauseOnHover: this.config.jdPauseOnHover
    };
    return {...defaultOptions, ...options};
  }
}
